export class ProjectAdapter {
  static toInputDTO(req: any): any {
    return {
      vendor_id: req.project_id,
    };
  }
}
